import * as Actions from "../actions";
import * as States from "../models/state";

const INITIAL_STATE: States.ILoginState = {
  email: "",
  password: ""
};

function loginReducer(
  state: States.ILoginState,
  action: Actions.IAction
): States.ILoginState {
  if (state === undefined) {
    return INITIAL_STATE;
  }

  switch (action.type) {
    case Actions.Types.EmailChanged:
      return {
        ...state,
        email: (action as Actions.Auth.IEmailChanged).email
      };

    case Actions.Types.PasswordChanged:
      return {
        ...state,
        password: (action as Actions.Auth.IPasswordChanged).password
      };

    default:
      return state;
  }
}

export default loginReducer;



// WEBPACK FOOTER //
// ./src/reducers/login.ts